import type { Nullable } from "@msuite/utils/types";
import { Menubar } from "radix-ui";
import { useNavigate } from "react-router";
import type { IconType } from "../../icons";
import type { ClassNameProps } from "../../types";
import { cn } from "../../utils";

/** Props Interface */
interface TopbarNavigationSubItemProps extends ClassNameProps {
	Icon: Nullable<IconType>;
	href: string;
	title: string;
}

export function TopbarNavigationSubItem({
	className,
	title,
	href,
	Icon,
}: TopbarNavigationSubItemProps) {
	const navigate = useNavigate();

	/** Render */
	return (
		<Menubar.Sub>
			<Menubar.Item
				onClick={() => {
					navigate(href);
				}}
				className={cn(
					"listbox-option-shape no-underline!",
					"hover:listbox-option-focused",
					"focus:listbox-option-focused",
					"transition-none!",
					className,
				)}
				data-cy={`navigation-sub-${title}`.toLowerCase()}
			>
				<div
					className="text-sm grid gap-0 items-center"
					style={{ gridTemplateColumns: "24px 1fr" }}
				>
					{Icon && <Icon />}
					<span className="col-start-2">{title}</span>
				</div>
			</Menubar.Item>
		</Menubar.Sub>
	);
}
